<template>
	<div class="sucess">
		<!-- 顶部导航 -->
		<div class="nav">
			<span></span>
			<span>消费交易</span>
			<span></span>
		</div>
		<!-- 支付成功 -->
		<div class="container">
			<img src="../../assets/sucess.png" alt="">
			<span>支付成功</span>
			<p>¥123456</p>
		</div>
		<!-- 详细信息 -->
		<van-cell-group>
			<van-cell title="订单号" value="1234567899874" />
			<van-cell title="交易方式" value="微信" />
			<van-cell title="交易时间" value="2019/12/11 11:30:30" />
			<van-cell title="交易状态" value="交易成功" />
		</van-cell-group>
		<!-- 按钮 -->
		<div class="btn">
			<button>查看详情</button>
			<button>返回首页</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		}
	}
</script>

<style scoped>
	@import "sucess.css";
</style>



// WEBPACK FOOTER //
// src/components/carts/sucess.vue